"use client"
import p1 from "../Images/Cherished One/p1.jpg"
import p2 from "../Images/Cherished One/p2.jpg"
import p3 from "../Images/Cherished One/p3.jpg"
import p4 from "../Images/Cherished One/p4.jpg"
import p5 from "../Images/Cherished One/p5.jpg"
import p6 from "../Images/Cherished One/p6.jpg"
import p7 from "../Images/Cherished One/p7.png"

import { useState, useEffect } from "react"

const CherishedOne = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  const testimonialsData = [
    {
      id: 1,
      name: "Parameswararao Gandrothu",
      image: p1,
      text: "My father's unwavering guidance and resilience continue to inspire my journey towards success, embodying strength and wisdom in every step taken.",
    },
    {
      id: 2,
      name: "Satyam Pentapati",
      image: p2,
      text: "My grandfather was a steadfast beacon of wisdom, his life a testament to resilience and unwavering kindness, His enduring legacy continues to inspire and guide generations with its timeless wisdom and grace.",
    },
    {
      id: 3,
      name: "Ramesh Raju Penmetsa",
      image: p7,
      text: "My teacher provides consistent support and encouragement, boosting my confidence and aiding my growth. Their guidance is invaluable, guiding me through challenges and motivating me to excel.",
    },
    {
      id: 4,
      name: "H H Sri Sri Ravi Shankar Ji",
      image: p6,
      text: "Sri Sri Ravi Shankar Ji, Indian yoga guru and founder of the Art of Living foundation. He introduced the transformative Sudarshan Kriya and spread spiritual courses globally since the 1980s.",
    },
    {
      id: 5,
      name: "Pawan Kalyan Konidela",
      image: p3,
      text: "Pawan Kalyan Konidela, a multifaceted Indian actor, renowned for his charismatic performances and unwavering commitment to social causes, embodies a unique blend of talent in the realm of Indian cinema.",
    },
    {
      id: 6,
      name: "Virat Kohli",
      image: p4,
      text: "Virat Kohli, a cricketing maestro, epitomizes sheer dedication and unparalleled prowess in the realm of sports, setting a benchmark for excellence with his phenomenal batting skills and inspirational leadership.",
    },
    {
      id: 7,
      name: "Ratan Naval Tata",
      image: p5,
      text: "Ratan Tata, a visionary leader and philanthropist, transformed the Tata Group into a global powerhouse, combining business acumen with a commitment to social responsibility.",
    },
  ]

  useEffect(() => {
    if (isAutoPlaying) {
      const timer = setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % testimonialsData.length)
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [currentSlide, isAutoPlaying, testimonialsData.length])

  const goToSlide = (index) => {
    setCurrentSlide(index)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 10000)
  }

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonialsData.length) % testimonialsData.length)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 10000)
  }

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonialsData.length)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 10000)
  }

  return (
    <section className="bg-bg-primary px-[9%] py-[10rem] relative" id="cherished">
      {/* Custom Shape Divider */}
    <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
      <svg
        className="relative block w-[calc(121%+1.3px)] h-[78px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path d="M1200 0L0 0 892.25 114.72 1200 0z" className="fill-bg-secondary"></path>
      </svg>
    </div>

      <div className="flex flex-col justify-center items-center relative z-10 pb-[60px]">
        <div className="relative flex justify-center items-center flex-col w-full max-w-[1350px] pt-[40px] gap-3">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold mt-20 text-white font-rowdies">
            Cherished One
          </h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-8">
            I hold a deep admiration for the individuals I cherish as my role models, valuing their qualities and
            achievements, which serve as inspiration for my personal and professional growth.
          </p>

          <div className="w-full relative">
            <div className="relative w-full max-w-[1020px] p-5 mx-auto">
              {/* Navigation Arrows */}
              <button
                onClick={goToPrevious}
                className="absolute left-[10px] top-1/2 -translate-y-1/2 text-blue-600 cursor-pointer text-[2em] transition-all duration-300 hover:text-gray-300 p-[5px] z-[22222222]"
              >
                <i className="fa fa-chevron-left"></i>
              </button>

              <button
                onClick={goToNext}
                className="absolute right-[10px] top-1/2 -translate-y-1/2 text-blue-600 cursor-pointer text-[2em] transition-all duration-300 hover:text-gray-300 p-[5px] z-[22222222]"
              >
                <i className="fa fa-chevron-right"></i>
              </button>

              {/* Dots Navigation */}
                <div className="text-center absolute w-full bottom-[60px] left-0 z-[3333] h-3">
                  {testimonialsData.map((_, index) => (
                    <span
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`inline-block w-3 h-3 rounded-full mx-[10px] cursor-pointer transition-all duration-300 ${currentSlide === index
                          ? 'bg-[#0066ff] border border-[#0066ff]'
                          : 'bg-transparent border border-white'
                        }`}
                    ></span>
                  ))}
                </div>

              {/* Content */}
              <div className="relative overflow-hidden">
                {testimonialsData.map((testimonial, index) => (
                  <div
                    key={testimonial.id}
                    className={`text-center absolute top-0 left-0 pb-[70px] transition-opacity duration-500 ${currentSlide === index ? "relative opacity-100" : "opacity-0"
                      }`}
                  >
                    <div className="block w-[100px] h-[100px] mx-auto rounded-full overflow-hidden mb-4">
                      <img
                        src={testimonial.image || "/placeholder.svg"}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h2 className="text-blue-600 text-[1.5em] my-[15px]">{testimonial.name}</h2>
                    <p className="text-[1.4rem] text-gray-300 w-4/5 mx-auto">{testimonial.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CherishedOne
